import CountUp from 'react-countup';

import { EStatisticType } from 'views/Statistics/StatisticsView.types';

import Typography from 'components/Typography/Typography';

import { PercentageChange } from './AnalyticsBoxHeader/PercentageChange';
import { getDecimalPlaces } from './utils';

type AnalyticsIndicatorProps = {
  currentValue?: number;
  metricType: EStatisticType;
  changePercentage?: number;
};

export const AnalyticsIndicator = ({
  currentValue,
  metricType,
  changePercentage,
}: AnalyticsIndicatorProps) => {

  return (
    <Typography tag="h2" className="text-base-cardForeground mt-3 mb-1.5">
      
       {currentValue && ( <CountUp
          prefix={
            metricType === EStatisticType.CURRENCY ||
            metricType === EStatisticType.AMOUNT_AVERAGE
              ? '$'
              : ''
          }
          suffix={metricType === EStatisticType.PERCENTAGE ? '%' : ''}
          decimal="."
          decimals={getDecimalPlaces(currentValue, metricType)}
          separator=","
          duration={1}
          end={currentValue}
        />)}
      
      <PercentageChange changePercentage={changePercentage} />
    </Typography>
  );
};
